export default "__VITE_ASSET__CvzZ3Ql4__"